/**
 * Debug utility: Fills the application form with test data.
 * Only used in development mode.
 */

const TEST_DATA: Record<string, string> = {
  salutation: 'mr',
  firstName: 'Max',
  lastName: 'Mustermann',
  email: 'max.mustermann@test.de',
  phone: '+49 170 1234567',
  street: 'Musterstraße',
  streetNumber: '42',
  additional: '2. OG',
  countryCode: 'DE',
  zipCode: '60311',
  city: 'Frankfurt am Main',
  birthday: '15.06.1990',
  birthplace: 'Berlin',
  fieldOfStudy: 'Informatik',
  lastAnnualSalary: '55000',
  lastAnnualSalaryCurrency: 'EUR',
  desiredSalary: '65000',
  earliestPossibleJoinDate: '01.09.2026',
  remark: 'Testbewerbung via Auto-Fill',
};

const setNativeInputValue = (el: HTMLInputElement | HTMLTextAreaElement, value: string) => {
  const proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
  const setter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
  if (setter) {
    setter.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
};

export const fillTestData = (form: HTMLFormElement) => {
  for (const [name, value] of Object.entries(TEST_DATA)) {
    // Try native select first
    const selectEl = form.querySelector<HTMLSelectElement>(`select[name="${name}"]`);
    if (selectEl) {
      selectEl.value = value;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      continue;
    }

    // Try input/textarea
    const inputEl = form.querySelector<HTMLInputElement | HTMLTextAreaElement>(
      `input[name="${name}"], textarea[name="${name}"]`,
    );
    if (inputEl) {
      // Skip file inputs
      if (inputEl instanceof HTMLInputElement && inputEl.type === 'file') continue;
      // For checkboxes, set checked
      if (inputEl instanceof HTMLInputElement && inputEl.type === 'checkbox') {
        if (value === 'on' && !inputEl.checked) {
          inputEl.click();
        }
        continue;
      }
      setNativeInputValue(inputEl, value);
      continue;
    }

    // Try hidden input (sui-core custom selects use hidden inputs)
    const hiddenEl = form.querySelector<HTMLInputElement>(`input[type="hidden"][name="${name}"]`);
    if (hiddenEl) {
      setNativeInputValue(hiddenEl, value);
    }
  }
};
